import React from "react";
import styled from "styled-components/macro";
import { device } from "../../device";

const pdfStyle = {
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  height: 940,
  gap: 24,
  width: 2044,
  padding: "0px 97px",
};
export default function FaqExpend({ isPDF }) {
  const QAcomp = ({ quesstion, answer }) => (
    <QaWrapper isPDF={isPDF}>
      <Quesstion>{quesstion}</Quesstion>
      <Answer isPDF={isPDF}>{answer}</Answer>
    </QaWrapper>
  );

  return (
    <FaqExpendWrapper style={isPDF && pdfStyle}>
      {isPDF ? (
        <Intro isPDF={isPDF} style={{ fontSize: 40, fontWeight: 800 }}>
          FAQ
        </Intro>
      ) : (
        <Intro>You Ask. We Answer.</Intro>
      )}

      <QAcomp
        quesstion={"What, if any, are the power or IT requirements?"}
        answer={
          "The unit runs off one regular 110-volt outlet. For IT, we can run off the building’s WiFi (if available) or the unit can work on TULU’s own network."
        }
      />
      <QAcomp
        quesstion={"How are products maintained?"}
        answer={
          "We provide each building with a dedicated admin app. Our team provides 24/7 support for maintenance, as well as assistance to the residents via chat and phone."
        }
      />

      <QAcomp
        quesstion={"What happens if a resident breaks an item?"}
        answer={
          "The products are part of the service — so anything that goes wrong will be fixed by us."
        }
      />
      {isPDF && (
        <>
          <BlankBox />

          <BlankBox />
          <BlankBox />

          <BlankBox style={{ height: 76 }} />
        </>
      )}
      <QAcomp
        quesstion={"How long does it take to install a unit?"}
        answer={
          "About four to six hours, depending on the size of the unit. We provide white-glove installation from our highly trained installation team. We also provide a COI to any buildings that require it."
        }
      />
      <QAcomp
        quesstion={"What if my building is in development?"}
        answer={
          "Our team will work with yours — architects, interior designers, contractors — to find the perfect location for the unit and adjust it specifically for your building."
        }
      />

      <QAcomp
        quesstion={"And what about liability?"}
        answer={"Our service provides full coverage from A to Z."}
      />
    </FaqExpendWrapper>
  );
}

const BlankBox = styled.div`
  width: 40%;
  height: 102px;
`;

const FaqExpendWrapper = styled.div`
  @media ${device.mobileS} {
    padding: 15px 40px 15px 39px;
  }
  @media ${device.tablet} {
    width: 1090px;

    padding: 25px 97px;
  }
`;

const Intro = styled.div`
  font-family: ${(props) => (props.isPDF ? "Lexend" : "DMSans")};
  color: #000;
  text-align: left;
  padding-bottom: 24px;
  @media ${device.mobileS} {
    font-size: 15px;
    line-height: 1.2;
  }
  @media ${device.tablet} {
    font-size: 20px;
    line-height: 1.32;
  }
`;

const QaWrapper = styled.div`
  font-family: DMSans;
  color: #000;
  text-align: left;
  line-height: 1.32;
  width: ${({ isPDF }) => isPDF && "40%"};
  @media ${device.mobileS} {
    font-size: 15px;
  }
  @media ${device.tablet} {
    font-size: ${({ isPDF }) => (isPDF ? "25px" : "20px")};
  }
`;

const Quesstion = styled.div`
  font-weight: bold;
`;

const Answer = styled.div`
  padding-bottom: 15px;
  @media ${device.mobileS} {
    font-size: 15px;
    padding-right: 10px;
  }
  @media ${device.tablet} {
    font-size: ${({ isPDF }) => (isPDF ? "25px" : "20px")};
    padding-right: 0px;
  }
`;
